import { Button, Modal } from "antd";
import "./OldBrowserModal.scss";

export interface OldBrowserModalProps {
  isVisible: boolean;
  onClose: () => void;
}

export function OldBrowserModal({ isVisible, onClose }: OldBrowserModalProps) {
  return (
    <Modal
      className={"clean one old-browser"}
      visible={isVisible}
      onCancel={() => onClose()}
    >
      <header>
        <h2>Outdated browser detected</h2>
      </header>

      <p>
        For the best experience, please upgrade your browser to the most current
        version.
      </p>

      <footer>
        <Button className={"primary"} size={"large"} onClick={onClose}>
          Okay
        </Button>
      </footer>
    </Modal>
  );
}
